import { render, staticRenderFns } from "./filtered_search_and_sort.vue.js?vue&type=template&id=d333f874!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./filtered_search_and_sort.vue?vue&type=template&id=d333f874"
import script from "./filtered_search_and_sort.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./filtered_search_and_sort.vue?vue&type=script&lang=js"
export * from "./filtered_search_and_sort.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./filtered_search_and_sort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d333f874')) {
      api.createRecord('d333f874', component.options)
    } else {
      api.reload('d333f874', component.options)
    }
    module.hot.accept("./filtered_search_and_sort.vue.js?vue&type=template&id=d333f874!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./filtered_search_and_sort.vue?vue&type=template&id=d333f874", function () {
      api.rerender('d333f874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "groups_projects/components/filtered_search_and_sort.vue"
export default component.exports